import { BRAND_CLASSIFICATION, MARKETPLACE_MINIMUM_PRICE } from 'domains/seller-product/constants'
import PriceUtil from 'utils/price-util'
import * as Yup from 'yup'

const sellerProductConvertToMarketProductFormSchema = (brandClassifications) => {
  const priceMinimum = minimumPrice(brandClassifications)
  return (
    Yup.object().shape({
      price_offer: Yup.number()
        .min(priceMinimum, `Harga minimal ${PriceUtil.formatToIDR(priceMinimum)}`)
        .required('Wajib diisi.')
    })
  )
}

/**
 * return conditional minimum price
 * if brand is luxury, minimum price is 1,7mio IDR
 * if brand is branded, minimum price is 500k IDR
 * @param {array} brandClassifications - Seller Product Brand classifications
 * @return {Number} minimum price for marketproduct
 */
const minimumPrice = (brandClassifications) => {
  const isBrandLuxury             = brandClassifications.includes(BRAND_CLASSIFICATION.LUXURY)
  const isBrandHighEndLuxury      = brandClassifications.includes(BRAND_CLASSIFICATION.HIGH_END_LUXURY)
  const isBrandAspirationalLuxury = brandClassifications.includes(BRAND_CLASSIFICATION.ASPIRATIONAL_LUXURY)
  if (isBrandLuxury || isBrandHighEndLuxury || isBrandAspirationalLuxury)
    return MARKETPLACE_MINIMUM_PRICE.LUXURY
  return MARKETPLACE_MINIMUM_PRICE.BRANDED
}

export default sellerProductConvertToMarketProductFormSchema
